const allowedCities = [
  "Bahawalpur",
  "Dera Ghazi Khan",
  "Faisalabad",
  "Gujranwala",
  "Gujrat",
  "Hyderabad",
  "Islamabad",
  "Jhang",
  "Karachi",
  "Lahore",
  "Larkana",
  "Multan",
  "Peshawar",
  "Quetta",
  "Rahim Yar Khan",
  "Rawalpindi",
  "Sargodha",
  "Sheikhupura",
  "Sialkot",
  "Sukkur",
];
export default allowedCities;
